import EmmyIcon from "~/Icons/emmyIcon.svg?component-solid";
import UserRatingIcon from "~/Icons/userRatingIcon.svg?component-solid";
import { getFileSrcToCdnOrRelative } from "~/solidJs/shared";
import Icons from "~/solidJs/shared/ui/atoms/IconsComp";
export const CreativeTeamsSection = () => {
	return (
		<section class="flex w-full flex-col items-center justify-center gap-4">
			<h1 class="m-0 font-semibold text-3xl">Trusted by creative teams</h1>
			<div class="flex w-full flex-wrap items-center justify-around gap-4">
				<Professionals />
				<Rating />
				<ProductHunt />
				<Awards />
			</div>
		</section>
	);
};
const Professionals = () => {
	return (
		<div class="flex flex-col items-center gap-2 text-xs">
			<h1 class="m-0 font-bold text-sm">70,000 professionals </h1>
			<p class="">have selected our product for their business tasks</p>
		</div>
	);
};
const Rating = () => {
	return (
		<div class="flex flex-col items-center justify-center gap-2 text-sm">
			4,9 User Ratings
			<UserRatingIcon class="h-6" />
		</div>
	);
};
const ProductHunt = () => {
	return (
		<a
			href="https://www.producthunt.com/posts/ai-library?utm_source=badge-top-post-badge&utm_medium=badge&utm_souce=badge-ai&#0045;library"
			target="_blank"
			rel="noreferrer"
			class="h-max"
		>
			<img
				src="https://api.producthunt.com/widgets/embed-image/v1/top-post-badge.svg?post_id=384936&theme=neutral&period=weekly"
				alt="AI&#0032;Library - The&#0032;biggest&#0032;free&#0032;library&#0032;of&#0032;1000&#0043;&#0032;AI&#0032;tools | Product Hunt"
				style="width: 250px; height: 54px;"
				class="h-auto w-full"
			/>
		</a>
	);
};

const Awards = () => {
	return (
		<div class="flex flex-col items-center justify-center">
			<h3 class="m-0 font-semibold text-xl">60+ world awards</h3>
			<div class="flex gap-2">
				<img alt="" class="size-16" src={getFileSrcToCdnOrRelative("redIcon.png")} />
				<Icons.Cannes.default class="size-16" />
				<EmmyIcon class="size-16" />
				<Icons.Webby.default class="size-16" />
			</div>
		</div>
	);
};
